
module dg.objects {

    export class DisplayLayoutController {

        public ObjectDisplayerController: ObjectDisplayerController;
        public propertyId: string;
        public options: any;
        public propMeta: dg.restfulApi.DomainObjectPropertyMetadata

        $onInit = () => {
            this.ObjectDisplayerController.OnValueChanged(this.valueChangedHandler);
        }

        valueChangedHandler = (newValue: dg.domain.IDomainObject) => {
            //let valueObject = this.ObjectDisplayerController.value;
            this.propMeta = newValue.dgMeta.properties[this.propertyId];
        }
    }
}